import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { ExpandableConfig, TableRowSelection } from 'antd/es/table/interface';
import { memo } from 'react';

interface IProps {
  data: any[];
  columns: ColumnsType<any>;
  loading: boolean;
  rowKey?: string;
  rowSelection?: TableRowSelection<any>;
  onRow?: any;
  expandable?: ExpandableConfig<any>;
}

function BaseTable(props: IProps) {
  const { innerHeight: height } = window;

  return (
    <Table
      dataSource={props.data}
      columns={props.columns}
      loading={props.loading}
      pagination={false}
      rowKey={props.rowKey || 'id'}
      size="middle"
      scroll={{ y: height - 300 }}
      rowSelection={props.rowSelection}
      onRow={props.onRow}
      expandable={props.expandable}
    />
  );
}

export default memo(BaseTable);
